import { render, staticRenderFns } from "./floorPlan.vue?vue&type=template&id=31cafb2c"
import script from "./floorPlan.vue?vue&type=script&lang=js"
export * from "./floorPlan.vue?vue&type=script&lang=js"
import style0 from "./floorPlan.vue?vue&type=style&index=0&id=31cafb2c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31cafb2c')) {
      api.createRecord('31cafb2c', component.options)
    } else {
      api.reload('31cafb2c', component.options)
    }
    module.hot.accept("./floorPlan.vue?vue&type=template&id=31cafb2c", function () {
      api.rerender('31cafb2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/floorPlan.vue"
export default component.exports